import {memo, useState} from 'react'
import {Diff} from '@github-ui/diff-lines'
import type {DiffEntry} from '@github-ui/diff-lines/types'
import {CodeownersBadge} from './CodeownersBadge'
import {MarkAsViewedButton} from './MarkAsViewedButton'
import {CommentIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import BlobActionMenu from './BlobActionMenu'
import styles from './PullRequestDiffsList.module.css'

export interface PullRequestDiffsListProps {
  diffs: DiffEntry[]
}

export const PullRequestDiffsList = memo(PullRequestDiffsListUnmemoized)

function PullRequestDiffsListUnmemoized({diffs}: PullRequestDiffsListProps) {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [diffManuallyExpanded, _] = useState(false)
  const [isViewed, setIsViewed] = useState(false)
  const commentingImplementation = undefined
  const markerNavigationImplementation = undefined
  const addInjectedContextLines = () => {}
  const onOptionCollapseToggle = (collapsed: boolean) => {
    setIsCollapsed(collapsed)
  }

  // TODO: get focused search result from the file tree
  const focusedSearchResult = undefined

  // TODO: get codeowners info from the API
  const codeownersInfo = {
    codeownerPath: `repo-name/blob/master/CODEOWNERS#L1`,
    ownedByCurrentUser: true,
    ownersForFile: 'pull-requests-reviewers',
    ruleForPathLine: '',
  }

  return (
    <>
      {diffs.map(diff => (
        <div key={diff.pathDigest} className={styles.entry}>
          <Diff
            focusedSearchResult={focusedSearchResult}
            collapsed={isCollapsed}
            diffManuallyExpanded={diffManuallyExpanded}
            commentingImplementation={commentingImplementation}
            markerNavigationImplementation={markerNavigationImplementation}
            rightSideContent={
              <div className="d-flex flex-items-center gap-2">
                {/*TODO: Re-work FileConversationsButton to work with our data */}
                <IconButton icon={CommentIcon} aria-label="Comment on this file" size="small" />
                <MarkAsViewedButton isViewed={isViewed} toggleViewed={() => setIsViewed(!isViewed)} />
                <BlobActionMenu
                  oid={diff.status === 'REMOVED' && diff.oldCommitOid ? diff.oldCommitOid : diff.newCommitOid || ''}
                  path={diff.path}
                  repo={diff.repository}
                  isViewable={!diff.isSubmodule}
                />
              </div>
            }
            leftSideContent={
              codeownersInfo && (
                <CodeownersBadge
                  /* These classes need to match the flex ordering specified in DiffFileHeader,
                  code badge currently looks strange on small screens.  */
                  className="d-flex px-1 flex-items-center flex-order-2 flex-sm-order-1"
                  {...codeownersInfo}
                />
              )
            }
            addInjectedContextLines={addInjectedContextLines}
            onOptionCollapseToggle={onOptionCollapseToggle}
            {...diff}
          />
        </div>
      ))}
    </>
  )
}

try{ PullRequestDiffsList.displayName ||= 'PullRequestDiffsList' } catch {}
try{ PullRequestDiffsListUnmemoized.displayName ||= 'PullRequestDiffsListUnmemoized' } catch {}